import { render, staticRenderFns } from "./PolicySubgroupDocumentsLog.vue?vue&type=template&id=5ff76e6a&"
import script from "./PolicySubgroupDocumentsLog.vue?vue&type=script&lang=js&"
export * from "./PolicySubgroupDocumentsLog.vue?vue&type=script&lang=js&"
import style0 from "./PolicySubgroupDocumentsLog.vue?vue&type=style&index=0&id=5ff76e6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports